import {IntermediatePart} from "../../parts/intermediatePart";
import {BathTubType, LayoutType} from "../../constants";

export default class BathTubBase extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'bathtub_base';
    this.visible = [BathTubType.Custom60in];
    this.partName = 'Base';
    this.translateId = "visualizer.bathroom.bathtub.bathtub_base";
    this.dbName = 'BathtubBase';
    this.homePageTitle = 'Bathtubs';
    this.canBeDisabled = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BathTubBase());
  }

  disabledClick() {
    const bathtubParent = this.getParent();
    [bathtubParent.bathtubRim, bathtubParent.bathTubSpa, bathtubParent.bathTubFixture].forEach(subPart => {
      if (subPart) {
        subPart.disabled = this.disabled;
      }
    });
    if (bathtubParent.layout.type === LayoutType.Small && !this.disabled) {   // switch off all shower features
      bathtubParent.layout.parts.Shower.showerBody.disabled = true;
      bathtubParent.layout.parts.Shower.showerBody.disabledClick();
    }
  }

  setDefault(layout) {
    const filteredFeatures = this.features;
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const sameStoneAsWalls = this.getParent().layout.parts.Walls.wallA.activeFeature
        && this.getParent().layout.parts.Walls.wallA.activeFeature.partName;
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes(sameStoneAsWalls || "Sahara Autumn  Porcelain Tile");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || super.setDefault(layout) || null;
    }
  }

  handleClick() {
    const bathtubParent = this.getParent().getParent();
    bathtubParent.bathTubType_ = BathTubType.Custom60in;
    bathtubParent.activeSubType_ = BathTubType.Custom60in;
    super.handleClick();
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType() === BathTubType.Custom60in) {
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndexes.BathTub.Custom60in.Base;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.BathTub.Custom60in.Base;
      }
    }
  }
}
